import { Component, OnInit } from '@angular/core';
import { IconBaseComponent } from '../icon-base/icon-base.component';

@Component({
  selector: 'app-icon-change',
  templateUrl: './icon-change.component.html',
  styleUrls: ['./icon-change.component.scss']
})
export class IconChangeComponent extends IconBaseComponent implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void {}
}
